﻿package com.mgacreative.hotel.feature.hotel.ui.auth

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

enum class AuthScreenType {
    LOGIN,
    REGISTER,
    FORGOT_PASSWORD
}

class AuthNavigator {
    private val _currentScreen = MutableStateFlow(AuthScreenType.LOGIN)
    val currentScreen: StateFlow<AuthScreenType> = _currentScreen.asStateFlow()

    fun navigateTo(screen: AuthScreenType) {
        _currentScreen.value = screen
    }
}
